import React from 'react';
import { Box, FormControl, Input, Typography } from '@mui/material';

// Define styles
const typographyStyle = {
  fontSize: '16px',
  color: '#5F5C5F',
  paddingBottom: 0.5,
  fontWeight: '500',
  fontFamily: "Buenos Aires",
};

const inputStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  border: '1px solid #DBDBDB',
  padding: '8px 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

// Component definition
const InputText = (props: any) => {
  const {
    fieldname,
    value,
    onChange,
    error,
    label,
    required = false,
    multiline = false,
    rows = 1,
  } = props;

  return (
    <Box sx={{ marginBottom: '15px' }}>
      {label && <Typography sx={typographyStyle}>{label}</Typography>}
      <FormControl fullWidth required={required} error={error}>
        <Input
          name={fieldname}
          disableUnderline
          multiline={multiline}
          rows={multiline ? rows : undefined}
          value={value}
          onChange={(e) => onChange(e.target.value, fieldname)}
          sx={inputStyle}
        />


      </FormControl>
    </Box>
  );
};

export default InputText;
